






import { defineComponent } from '@nuxtjs/composition-api'
import { useProductStore } from '~/store/product'

import PanelBuilder from '@/components/feature/PDP/PanelBuilder.vue'
import { useStickyPdpComponent } from '~/composables/ui/useStickyPdpComponent'

export default defineComponent({
  components: { PanelBuilder },
  setup() {
    const { currentProduct } = useProductStore()
    const productId = currentProduct.data.key

    const { stickyStyle, wrapperRef, isSticky } = useStickyPdpComponent()

    return {
      productId,
      stickyStyle,
      wrapperRef,
      isSticky,
    }
  },
})
